import { atom } from 'jotai';

import { updateV2SocketData } from '../v2-helper';
import { createTableAccumulatorBunja } from './table-accumulator';

export type Wallets = Record<string, Wallet> | null;

export interface Wallet {
  walletBalanceInUsdt: string;
  walletBalanceExclWithdrawalPending: string; // walletBalanceInUsdt - pending withdrawals
  walletBalanceExclWithdrawalPendingInUsdt: string;
  walletBalanceWithdrawable: string;
  walletBalanceWithdrawableInUsdt: string;
  walletBalanceExclLocked: string;
  walletBalanceStaked: string;
  walletBalanceStakedInUsdt: string;
  pnlPct: string | null;
  pnl: string | null;
  avgEntryPrice: string | null;
}

export const walletsAtom = atom<Wallets>(null);

export const subscribeWalletsBunja = createTableAccumulatorBunja(
  'private/wallets',
  (store) => (wsData) => store.set(walletsAtom, (prev) => updateV2SocketData(prev || {}, wsData)),
);
